import { render } from "./GuidesList.vue?vue&type=template&id=73717f0e&ts=true"
import script from "./GuidesList.vue?vue&type=script&lang=ts"
export * from "./GuidesList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__